module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": _vm.title,
      "url": '/agreements/' + (this.telcoId ? '/org/' + this.telcoId : ''),
      "table-ref": "agreements-table",
      "fields": _vm.fields,
      "hide-top": _vm.hideTop,
      "show-search": _vm.showSearch,
      "show-refresh": _vm.showRefresh,
      "search-placeholder": _vm.searchPlaceholder,
      "add-action": _vm.noAdd ? null : _vm.action,
      "add-props": _vm.noAdd ? null : _vm.addPropsData,
      "detail-component": "agreement-detail-row"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2f3068a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/rates/AgreementsTable.vue
// module id = 1738
// module chunks = 0